import React from "react";

import Button from "@material-ui/core/Button";

const MButton = props => (
  <Button
    className={" FontPoppins"}
    style={{ textTransform: "capitalize" }}
    {...props}
  >
    {props.children}
  </Button>
);

export default MButton;
